var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirstStepIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "#00995D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3013 55C40.9173 55 40.5813 54.868 40.2933 54.604C40.0293 54.34 39.8973 54.004 39.8973 53.596V30.196L36.2973 31.456C36.0333 31.576 35.7933 31.636 35.5773 31.636C35.1693 31.636 34.8333 31.504 34.5693 31.24C34.3053 30.976 34.1733 30.652 34.1733 30.268C34.1733 29.98 34.2333 29.716 34.3533 29.476C34.4973 29.236 34.7373 29.056 35.0733 28.936L40.6173 27.028C40.7373 26.98 40.8573 26.944 40.9773 26.92C41.1213 26.872 41.2413 26.848 41.3373 26.848C41.7453 26.848 42.0693 26.992 42.3093 27.28C42.5733 27.544 42.7053 27.868 42.7053 28.252V53.596C42.7053 54.004 42.5733 54.34 42.3093 54.604C42.0453 54.868 41.7093 55 41.3013 55Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstStepIcon);
export default __webpack_public_path__ + "static/media/first-step-icon.1e0475e4d40f6da02c653213483eca16.svg";
export { ForwardRef as ReactComponent };